var map = {
	"./Dr.A.Shanmugam.jpg": 31015,
	"./Dr.B.Meenakshi Priya.jpg": 95041,
	"./Dr.C.Maheswari.jpeg": 78148,
	"./Dr.E.B.Priyanka.jpeg": 45764,
	"./Dr.K.Gomathi.jpeg": 18740,
	"./Dr.K.Krishnamurthy.jpg": 86201,
	"./Dr.K.Suganeswaran.jpeg": 42370,
	"./Dr.N.Muralidharan.jpeg": 20752,
	"./Dr.N.Nithyavathy.jpeg": 16853,
	"./Dr.P.M.Arunkumar.jpg": 52914,
	"./Dr.P.Ravichandran.jpeg": 93275,
	"./Dr.R.Nithyaprakash.jpeg": 52107,
	"./Dr.S.Arunkumar.png": 55138,
	"./Dr.S.K.Thangarasu.jpeg": 20714,
	"./Dr.S.Praveen kumar.jpeg": 21984,
	"./Dr.S.Thangavel.jpg": 10804,
	"./Dr.T.Tamilarasi.jpeg": 16429,
	"./Dr.V.G.Pratheep.jpg": 71931,
	"./Dr.V.K.Gobitnath.jpeg": 87855,
	"./Megavarthini.jpg": 18218,
	"./Mr.C.Anbu.jpeg": 81156,
	"./Mr.T.Surendran.jpeg": 68323,
	"./S.Karthikeyan.jpg": 1691,
	"./santhosh.jpg": 75923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51635;